import {
  Box,
  Skeleton,
  Stack,
  StackDivider,
  VStack,
  FormControl,
  FormLabel,
  Input,
  HStack,
} from '@chakra-ui/react'
import { FieldGroup } from '@components/Forms/Layout/FieldGroup'
import { UserLayout } from '@components/Layouts/UserLayout'
import { UpdateEmailModal } from '@components/Modals/UpdateEmailModal'
import { UpdatePasswordModal } from '@components/Modals/UpdatePasswordModal'
import { useMeQuery } from '@features/users/api'
import { UpdateProfileForm } from '@features/users/components/UpdateProfileForm'

import { createFileRoute } from '@tanstack/react-router'

const SettingsPage = () => {
  const { data: userData, isLoading } = useMeQuery(null, {
    refetchOnMountOrArgChange: true,
  })

  return (
    <UserLayout>
      <Box py="8" maxWidth="5xl" mx="auto">
        <Skeleton isLoaded={!isLoading}>
          {userData !== undefined && (
            <Stack spacing="4" divider={<StackDivider />}>
              <UpdateProfileForm userData={userData} />
              <FieldGroup title="Login details">
                <VStack width="full">
                  <FormControl id="email">
                    <FormLabel>Email</FormLabel>
                    <Input
                      name="email"
                      type="email"
                      value={userData?.emailAddress ?? ''}
                      isReadOnly
                      variant="unstyled"
                    />
                  </FormControl>
                  <HStack width="full">
                    <UpdateEmailModal defaultEmail={userData.emailAddress} />
                    <UpdatePasswordModal />
                  </HStack>
                </VStack>
              </FieldGroup>
            </Stack>
          )}
        </Skeleton>
      </Box>
    </UserLayout>
  )
}

const SettingsRoute = () => <SettingsPage />

export const Route = createFileRoute('/_auth/settings/')({
  component: SettingsRoute,
})
